module.exports = __webpack_public_path__ + "static/img/IL@2x.87c257ff.jpg";